import React from 'react'

const FooterBottom = () => {
  return (
    <div className="w-full py-10">
      <p className="text-center text-gray-500 text-base">
        All rights reserved by Haresh Kumar  ©2025
      </p>
    </div>
  );
}

export default FooterBottom
